module.exports = __webpack_public_path__ + "img/200601.d45fb69d.png";